// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"62":"6a7e8e25","364":"52191383","951":"7a767fbd"}[chunkId] + ".chunk.css";
};